export default __webpack_public_path__ + "static/media/woman-2.298f388e.png";